import { render, staticRenderFns } from "./detail.html?vue&type=template&id=cb46d518&scoped=true&external"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=cb46d518&prod&scoped=true&lang=css"
import style1 from "./detail.vue?vue&type=style&index=1&id=cb46d518&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb46d518",
  null
  
)

export default component.exports